import dayjs from "dayjs";
import type { SeriesLineOptions } from "highcharts";
import ReactDOMServer from "react-dom/server";

import type { SimplifiedSeries } from "@similarweb/pro-logic-components";
import { combineConfigs } from "@similarweb/pro-logic-components";

import { toggleItems } from "app/components/widget/widget-utilities/time-granularity";
import { minAbbrNumberFilter, percentageSignOnlyOrZeroFilter } from "app/filters/ngFilters";
import { type ICurrency, currenciesList } from "app/common/constants/currencies";

import type { IFormatter } from "../types";

import { getTooltipFormatter } from "./tooltip";

interface PpcChartConfigProps {
    chartData?: SimplifiedSeries<SeriesLineOptions>;
    isPercentage?: boolean;
    selectedCurrency?: ICurrency;
    yAxisFormatter?: IFormatter;
    xAxisFormatter?: IFormatter;
    volumeFilter?: IFormatter;
}

export const getPpcChartConfig = ({
    chartData = [],
    isPercentage = false,
    selectedCurrency = currenciesList[0],
    yAxisFormatter = isPercentage
        ? ({ value }) => percentageSignOnlyOrZeroFilter()(value, 0)
        : ({ value }) => minAbbrNumberFilter()(value),
    xAxisFormatter = ({ value }) => dayjs.utc(value).utc().format(toggleItems.Monthly.format),
    volumeFilter,
}: PpcChartConfigProps) => {
    const tooltipFormatter = getTooltipFormatter({ chartData, selectedCurrency, volumeFilter, isPercentage });
    const height = 250;

    return combineConfigs({}, [
        {
            tooltip: {
                followPointer: false,
                shared: true,
                outside: false,
                useHTML: true,
                formatter: function () {
                    if (!tooltipFormatter) {
                        return;
                    }
                    return ReactDOMServer.renderToString(<>{tooltipFormatter.call(this)}</>);
                },
            },
            chart: {
                height,
            },
            plotOptions: {
                area: {
                    stacking: "percent",
                    fillOpacity: 1,
                },
            },
            xAxis: {
                labels: {
                    formatter: function () {
                        return xAxisFormatter({ value: this.value });
                    },
                },
            },
            yAxis: {
                labels: {
                    formatter: function () {
                        return yAxisFormatter({ value: this.value });
                    },
                },
            },
        },
    ]);
};
